import React, {Component} from 'react';
import {routes} from "./routes";
import {HashRouter as Router, Route, Switch} from "react-router-dom";
import {injectIntl} from "react-intl";

class Content extends Component {

    render() {

        return (
            <div className='min-height-100vh'>
                <Router>
                    <Switch>
                        {routes.map(route => {
                            return (
                                <Route
                                    exact
                                    key={route.path}
                                    path={route.path}
                                    component={route.component}/>
                            )
                        })
                        }
                    </Switch>
                </Router>
            </div>
        )
    }
}

export default injectIntl(Content)

